/**
 * router/routes/aplicativos.routes.ts
 * "Aplicativos" — standalone tenant-facing utilities (AFIP↔Tango conciliator)
 * nested under the tenant AppShell. Split out of router/index.ts
 * (openspec/arquitectura/convencion-modulo.md §4).
 */
import type { RouteRecordRaw } from 'vue-router';

export const aplicativosRoutes: RouteRecordRaw[] = [
  // Aplicativos: /aplicativos/conciliador-afip — AFIP↔Tango conciliator (Parte 3 RIGX).
  // Capability-gated: aplicativos:conciliador-afip. Backend is the authority;
  // meta.requiresCapability provides a cosmetic frontend redirect for unauthorized users.
  {
    path: 'aplicativos/conciliador-afip',
    name: 'conciliador-afip',
    component: () => import('../../views/aplicativos/ConciliadorAfipView.vue'),
    meta: { requiresCapability: 'app.conciliador-afip.usar' },
  },
];
